import React from 'react';
import useTheme from '../../utils/styles/theme/useTheme';
import View from './View';
import Text from './Text';
import { css } from 'styled-components';
import Link from './Link';

export default function SimpleBanner({ children, url }) {
  const { colors } = useTheme();
  return (
    <Link href={url} target="_blank">
      <View
        backgroundColor={colors.primary.neutral}
        // layout={{ text: { color: colors.light.primary } }}
        css={css`
          min-height: 50px;
          max-height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          padding: 0 20px;
          text-align: center;
        `}
      >
        <Text>{children}</Text>
      </View>
    </Link>
  );
}
